import type { LucideIcon } from "lucide-react";
import {
  LayoutDashboard,
  ShieldCheck,
  Building2,
  Users,
  School,
  GraduationCap,
  Calendar,
  FileText,
  History,
  Bot,
  FileType2,
  Megaphone,
  BookMarked,
  BookOpen,
  DollarSign,
  Database,
  Globe,
} from "lucide-react";
import { MODULE_KEYS, type ModuleKey } from "@/lib/adminModules";

/**
 * Single source of truth for module -> icon, shared by the sidebar
 * (Layout/index.tsx) and the Guide page so they can never drift apart.
 */
export const MODULE_ICONS: Record<ModuleKey, LucideIcon> = {
  [MODULE_KEYS.DASHBOARD]: LayoutDashboard,
  [MODULE_KEYS.GUIDE]: BookMarked,
  [MODULE_KEYS.ADMIN_MANAGEMENT]: ShieldCheck,
  [MODULE_KEYS.AGENCIES]: Building2,
  [MODULE_KEYS.COUNSELORS]: Users,
  [MODULE_KEYS.COLLEGES]: School,
  [MODULE_KEYS.STUDENTS]: GraduationCap,
  [MODULE_KEYS.CALENDAR]: Calendar,
  [MODULE_KEYS.COUNSELOR_RESOURCES]: FileText,
  [MODULE_KEYS.CMS_COLLECTIONS]: Database,
  [MODULE_KEYS.WEBSITE_CONTENT]: Globe,
  [MODULE_KEYS.SESSIONS]: History,
  [MODULE_KEYS.AI_SESSIONS]: Bot,
  [MODULE_KEYS.TEMPLATES]: FileType2,
  [MODULE_KEYS.CAMPAIGNS]: Megaphone,
  [MODULE_KEYS.AI_GUIDELINES]: BookOpen,
  [MODULE_KEYS.AI_COSTS]: DollarSign,
};
